module.exports = __webpack_public_path__ + "static/media/community-top--resized.6e3ee833.jpg";